<div class="edit-modal">
  <div class="edit-modal__dialog">
    <div class="edit-modal__body">

      <div class="edit-modal__nav">
        <div class="edit-modal__nav-title" id="edit-modal-nav-content-demo">
          <h6>Edit your policy</h6>
        </div>
        <div class="edit-modal__nav-title  d-none" id="edit-modal-nav-review-demo">
          <button class="edit-modal__nav-title-back" (click)="goBackToEdit()" id="edit-modal-nav-review-back-demo">
            <svg class="icon">
              <use xlink:href="#arrow-left-small"></use>
            </svg>
          </button>
          <h6>Review your changes</h6>
        </div>
        <div class="edit-modal__nav-title d-none" id="edit-modal-nav-uw-demo">
          <h6>Underwriting</h6>
        </div>
        <div class="edit-modal__nav-actions">
          <button (click)="openSidesheet()" class="edit-modal__nav-action-help">
            <svg class="icon">
              <use xlink:href="#help-Icon"></use>
            </svg>
          </button>
          <button class="button-control button-control--grey" (click)="closeEditModal()" data-dismiss="edit-modal"><strong>Exit</strong></button>
        </div>
      </div>

      <div class="edit-modal__content" [ngClass]="menuState" id="edit-modal-content-demo">

        <!-- select column -->
        <div class="edit-modal__content-col">
          <div class="edit-modal__content-body">
            <div class="edit-modal__summary">

              <div class="edit-company">
                <div class="edit-company__name">
                  <strong>{{item?.product_name}}</strong>
                </div>
                <div class="edit-company__logo">
                  <img src="{{item?.underwriter_logo}}" class="img-fluid" />
                </div>
                <div class="edit-company__price">
                  @if (!isCalcPremLoading) {
                    @if (premiumCollation && premiumCollation?.prem_diff !== 0) {
                      <p class="price price--strikeout"><strong><em>{{accounting?.formatMoney(premiumCollation?.curr_prem_value)}}</em></strong> /{{item?.frequency_short}}</p>
                    }
                    @if (premiumCollation) {
                      <p class="price"><strong><em>{{accounting?.formatMoney(premiumCollation?.new_prem_value)}}</em></strong> /{{item?.frequency_short}}</p>
                    }
                    @if (!premiumCollation) {
                      <p  class="price"><strong><em>{{accounting?.formatMoney(item?.prem_value)}}</em></strong> /{{item?.frequency_short}}</p>
                    }
                  } @else {
                    <div class="loading-skeleton__text" style="width: 80px; height: 1.2em;"></div>
                  }
                </div>
                <div class="edit-company__fees">
                  <p>
                    Including Taxes and Fees
                    <a
                      class="popover-trigger popover-trigger--hover popover-trigger--sm"
                      tabindex="0"
                      data-toggle="popover"
                      data-html="true"
                      data-trigger="focus"
                      [attr.data-content]="fees"
                      data-original-title=""
                      title=""
                      >
                      <svg class="icon icon--sm"><use xlink:href="#help-Icon"></use></svg>
                    </a>
                  </p>
                </div>
              </div>

              <div class="actions mt-20">

                <!-- mobile ... add-->
                <a href="#edit-modal-add-menu" data-toggle="modal" class="action-icon d-md-none">
                  <div class="action-icon__icon">
                    <svg class="icon">
                      <use xlink:href="#add-items"></use>
                    </svg>
                  </div>
                  <small class="action-icon__label">Add</small>
                </a>

                <!-- desktop ... add-->
                <div class="dropdown d-none d-md-block">
                  <a href="#" data-toggle="dropdown" class="action-icon" aria-expanded="false">
                    <div class="action-icon__icon">
                      <svg class="icon">
                        <use xlink:href="#add-items"></use>
                      </svg>
                    </div>
                    <small class="action-icon__label">Add</small>
                  </a>
                  <div class="dropdown-menu dropdown-menu--central">
                    <a href="javascript:;" (click)="addCover()" class="dropdown-item">
                      <svg class="icon"><use xlink:href="#insured-items-add"></use></svg>
                      <span>Add an insured item</span>
                    </a>
                    <a href="javascript:;" (click)="addBenefit()"  class="dropdown-item">
                      <svg class="icon"><use xlink:href="#benefit-add"></use></svg>
                      <span>Add a benefit</span>
                    </a>
                  </div>
                </div>


                <!-- mobile ... pause-->
                <!-- <a href="#edit-modal-pause-menu" (click)="pauseCover(Entities.Policy)" data-toggle="modal" class="action-icon d-md-none">
                <div class="action-icon__icon">
                  <svg class="icon">
                    <use xlink:href="#pause"></use>
                  </svg>
                </div>
                <small class="action-icon__label">Pause</small>
              </a> -->
              <a href="#edit-modal-remove-menu" data-toggle="modal" class="action-icon d-md-none">
                <div class="action-icon__icon">
                  <svg class="icon">
                    <use xlink:href="#trash-bin"></use>
                  </svg>
                </div>
                <small class="action-icon__label">Remove</small>
              </a>
              <!-- <a href="#cancel-alert-modal" (click)="cancelCover(Entities.Policy)" data-toggle="modal" class="action-icon d-md-none">
              <div class="action-icon__icon">
                <svg class="icon">
                  <use xlink:href="#trash-bin"></use>
                </svg>
              </div>
              <small class="action-icon__label">Cancel this policy</small>
            </a> -->

            <!-- desktop ... pause-->
            <div class="dropdown d-none d-md-block">
              <a href="javascript:;" data-toggle="dropdown"  class="action-icon" aria-expanded="false">
                <div class="action-icon__icon">
                  <svg class="icon">
                    <use xlink:href="#trash-bin"></use>
                  </svg>
                </div>
                <small class="action-icon__label">Remove</small>
              </a>
              <div class="dropdown-menu dropdown-menu--central">

                <a href="#remove-insured-select-modal" data-toggle="modal" class="dropdown-item">
                  <svg class="icon"><use xlink:href="#insured-items-pause"></use></svg>
                  <span>Remove an insured item</span>
                </a>
                <a href="#remove-benefit-select-modal" data-toggle="modal" class="dropdown-item">
                  <svg class="icon"><use xlink:href="#benefit-pause"></use></svg>
                  <span>Remove a benefit</span>
                </a>

              </div>
            </div>

            <!-- <a href="#cancel-alert-modal" (click)="cancelCover(Entities.Policy)" data-toggle="modal" class="action-icon">
            <div class="action-icon__icon">
              <svg class="icon">
                <use xlink:href="#trash-bin"></use>
              </svg>
            </div>
            <small class="action-icon__label">Cancel this policy</small>
          </a> -->



          <!-- mobile ... more-->
          <a href="#edit-modal-more-menu" data-toggle="modal" class="action-icon d-md-none">
            <div class="action-icon__icon">
              <svg class="icon">
                <use xlink:href="#more"></use>
              </svg>
            </div>
            <small class="action-icon__label">More</small>
          </a>

          <!-- desktop ... more-->
          <div class="dropdown d-none d-md-block">
            <a href="#" data-toggle="dropdown" class="action-icon" aria-expanded="false">
              <div class="action-icon__icon">
                <svg class="icon">
                  <use xlink:href="#more"></use>
                </svg>
              </div>
              <small class="action-icon__label">More</small>
            </a>
            <div class="dropdown-menu dropdown-menu--central">


              <a href="javascript:;" (click)="cancelCover(Entities.Policy)" data-toggle="modal" class="dropdown-item">
                <svg class="icon">
                  <use xlink:href="#cancelled"></use>
                </svg>
                <span>Cancel this policy</span>
              </a>

              <!-- <a href="javascript:;" (click)="openInceptionDateModal()" class="dropdown-item">
              <svg class="icon">
                <use xlink:href="#circle-change"></use>
              </svg>
              <span>Change inception date</span>
            </a> -->
            <a href="javascript:;" class="dropdown-item is-disabled">
              <svg class="icon">
                <use xlink:href="#circle-change"></use>
              </svg>
              <span>Change product</span>
            </a>

          </div>
        </div>


      </div>

    </div>

    <div class="edit-modal__menu">

      <nav class="edit-nav edit-nav--select">
        <ul>
          <li id="overview" class="is-active">
            <a href="javascript:;" (click)="openEditModalItems($event, 'items-overview')">
              <p><span>Overview</span></p>
            </a>
          </li>
          <li id="demo-changes-menu-item" [ngClass]="questionChanged ? 'has-notice' : ''">
            <a href="javascript:;" (click)="openEditModalItems($event, 'items-insured-items')">
              <p><span>Insured items</span></p>
            </a>
          </li>
          @if (item?.included?.length > 0 || addons?.length > 0) {
            <li >
              <a href="javascript:;" (click)="openEditModalItems($event, 'items-benefits')">
                <p><span>Benefits</span></p>
              </a>
            </li>
          }
        </ul>
      </nav>


    </div>

  </div>
</div>

<!-- items column -->
<div class="edit-modal__content-col">

  <div id="items-overview" class="edit-modal__content-wrap">

    <!-- overview -->
    <div class="edit-modal__content-header d-md-none">

      <div class="edit-modal__back">
        <button class="edit-modal__back-arrow" (click)="switchEditModalState('select-active')">
          <svg class="icon">
            <use xlink:href="#arrow-left-small"></use>
          </svg>
        </button>
        <div class="edit-modal__back-title d-md-none">
          <a href="#modal-traymenu-insured-items" data-toggle="modal">
            <strong>
              Policy overview
            </strong>
          </a>
        </div>
      </div>

    </div>
    <div class="edit-modal__content-body">

      <div class="edit-modal__menu">
        <nav class="edit-nav edit-nav--items">
          <ul>
            <li>
              <a href="javascript:;" (click)="openEditModalItem($event, 'item-overview-policyholder-details')">
                <p><span>Policyholder details</span></p>
              </a>
            </li>
            <li>
              <a href="javascript:;" (click)="openEditModalItem($event, 'item-overview-payment-details')">
                <p><span>Payment details</span></p>
              </a>
            </li>
          </ul>
        </nav>
      </div>

    </div>

  </div>

  <div id="items-insured-items" class="edit-modal__content-wrap d-none">
    <!-- insured items -->
    <div class="edit-modal__content-header">

      <div class="edit-modal__back">
        <button class="edit-modal__back-arrow" (click)="switchEditModalState('select-active')">
          <svg class="icon">
            <use xlink:href="#arrow-left-small"></use>
          </svg>
        </button>
        <div class="edit-modal__back-title d-md-none">
          <a href="#modal-traymenu-insured-items" data-toggle="modal">
            <strong>
              {{selectedFilter}}
            </strong>
            <svg class="icon">
              <use xlink:href="#chevron-right-small"></use>
            </svg>
          </a>
        </div>
        <div class="edit-modal__back-title d-none d-md-block">

          <div class="dropdown dropdown--persist">
            <a href="#" data-toggle="dropdown">
              <strong>
                {{selectedFilter}}
              </strong>
              <svg class="icon">
                <use xlink:href="#chevron-right-small"></use>
              </svg>
            </a>
            <div class="dropdown-menu dropdown-menu--right">
              <a href="javascript:;" class="dropdown-item is-active dd-0" (click)="setFilterClass('All',0)">All insured items</a>
              @for (class of classes; track class) {
                @if (getClassItems(class?.class_id)?.length > 0) {
                  <a href="javascript:;" class="dropdown-item dd-{{class?.class_id}}" (click)="setFilterClass(class,0)"> {{class?.description_1}}</a>
                }
              }

            </div>
          </div>

        </div>
      </div>

      <div class="edit-modal__filters">
        <button class="edit-modal__filters-search" data-target="insured-search">
          <svg class="icon">
            <use xlink:href="#search"></use>
          </svg>
        </button>
        <button class="edit-modal__filters-sort is-desc">
          <svg class="icon">
            <use xlink:href="#sort-price-high-to-low"></use>
          </svg>
          <svg class="icon">
            <use xlink:href="#sort-price-low-to-high"></use>
          </svg>
        </button>
      </div>

      <div class="edit-modal__search" id="insured-search">
        <input class="edit-modal__search-input" type="search" autocomplete="off" placeholder="Search for an item">
        <button class="edit-modal__search-close">
          <svg class="icon">
            <use xlink:href="#close-medium"></use>
          </svg>
        </button>
      </div>

    </div>
    <div class="edit-modal__content-body">

      <div class="edit-modal__menu">

        <nav class="edit-nav edit-nav--items">
          <div class="edit-nav__group">
            @if (locations?.length > 0) {
              <div class="edit-nav__title class">
                Locations
              </div>
            }
            <ul>
              @for (location of locations; track location; let i = $index) {
                <li id="demo-changes-menu-subitem" class="location"
                  class="class location-{{i}}"
                  >
                  <a href="javascript:;" (click)="openEditModalItem($event, 'item-insured-items', location)">
                    <p>
                      <span>{{location?.answer}}</span>
                    </p>
                  </a>
                </li>
              }
            </ul>
          </div>
          @for (class of classes; track class) {
            <div class="edit-nav__group">
              @if (getClassItems(class?.class_id)?.length > 0) {
                <div class="edit-nav__title class class-{{class?.class_id}}">{{class?.description_1}}</div>
              }
              <ul>
                @for (item of getClassItems(class?.class_id); track item) {
                  <li id="demo-changes-menu-subitem" class="class class-{{class?.class_id}}-item-{{item?.session_item_id}} class-{{class?.class_id}}">
                    <a href="javascript:;" (click)="openEditModalItem($event, 'item-insured-items', item)">
                      <p>
                        <span>{{getDescription(0,item?.description_1)}}</span>
                        <small>{{item?.description_2}}</small>
                      </p>
                    </a>
                  </li>
                }
              </ul>
            </div>
          }

        </nav>


      </div>

    </div>

  </div>

  <div id="items-benefits" class="edit-modal__content-wrap d-none">
    <!-- benefits -->
    <div class="edit-modal__content-header">

      <div class="edit-modal__back">
        <button class="edit-modal__back-arrow" (click)="switchEditModalState('select-active')">
          <svg class="icon">
            <use xlink:href="#arrow-left-small"></use>
          </svg>
        </button>
        <div class="edit-modal__back-title d-md-none">
          <a href="#modal-traymenu-benefits" data-toggle="modal">
            <strong>
              {{selectedFilter}}
            </strong>
            <svg class="icon">
              <use xlink:href="#chevron-right-small"></use>
            </svg>
          </a>
        </div>
        <div class="edit-modal__back-title d-none d-md-block">

          <div class="dropdown dropdown--persist">
            <a href="#" data-toggle="dropdown">
              <strong>
                {{selectedFilter}}
              </strong>
              <svg class="icon">
                <use xlink:href="#chevron-right-small"></use>
              </svg>
            </a>
            <div class="dropdown-menu dropdown-menu--right">
              <a href="javascript:;" class="dropdown-item is-active dd-0" (click)="setFilterClass('All',1)">All benefits</a>
              @for (class of getBenefitsClasses(); track class) {
                <a href="javascript:;"  class="dropdown-item dd-{{class?.class_id}}" (click)="setFilterClass(class,1)"> {{class?.class_name}}</a>
              }

            </div>
          </div>

        </div>
      </div>

      <div class="edit-modal__filters">
        <button class="edit-modal__filters-search" data-target="benefits-search">
          <svg class="icon">
            <use xlink:href="#search"></use>
          </svg>
        </button>
        <button class="edit-modal__filters-sort is-desc">
          <svg class="icon">
            <use xlink:href="#sort-price-high-to-low"></use>
          </svg>
          <svg class="icon">
            <use xlink:href="#sort-price-low-to-high"></use>
          </svg>
        </button>
      </div>

      <div class="edit-modal__search" id="benefits-search">
        <input class="edit-modal__search-input" type="search" autocomplete="off" placeholder="Search for an item">
        <button class="edit-modal__search-close">
          <svg class="icon">
            <use xlink:href="#close-medium"></use>
          </svg>
        </button>
      </div>

    </div>
    <div class="edit-modal__content-body">

      <div class="edit-modal__menu">

        <nav class="edit-nav edit-nav--items">
          @for (class of getBenefitsClasses(); track class) {
            <div class="edit-nav__group">
              <div class="edit-nav__title class class-{{class?.class_id}}">{{class?.class_name}}</div>
              <ul>
                @for (addon of this.addons; track addon) {
                  <li class="class class-{{class?.class_id}}">
                    @if (class?.class_id === addon?.class_id) {
                      <a href="javascript:;" (click)="openEditModalItem($event, 'item-benefits', addon)">
                        <p><span>{{addon?.description_1}}</span></p>
                      </a>
                    }
                  </li>
                }
                @for (key of objectKeys(included); track key) {
                  <li class="class class-{{class?.class_id}}">
                    @if (class?.class_id === included[key]?.class_id) {
                      <a  href="javascript:;" (click)="openEditModalItem($event, 'item-benefits', included[key])">
                        <p><span>{{included[key]?.vaps_name}}</span></p>
                      </a>
                    }
                    <!-- <ul>
                    <li *ngFor="let item of included[key]?.items">
                      <a href="javascript:;" (click)="openEditModalItem($event, 'item-benefits', item)">
                        <p><span>{{item?.detail}}</span></p>
                      </a>
                    </li>
                  </ul> -->
                </li>
              }
            </ul>
          </div>
        }

      </nav>
    </div>

  </div>
</div>


</div>

<!-- item column -->
<div class="edit-modal__content-col">
  <div class="edit-modal__content-notice" id="edit-modal-changes-notice-demo" [class.d-none]="!changesTrayVisible">
    <app-highlight-message
      variant="info"
      icon="changes"
      message="You've made changes to this insured item, when you're happy, tap &quot;Review and commit&quot;"
      additionalClasses="notice--flush">
      <a
        highlightMessageTray="primary"
        href="#discard-changes-modal"
        data-toggle="modal"
        class="button button--sm"
        id="discard-changes-modal-trigger">Discard changes</a>
    </app-highlight-message>
  </div>
  <div id="edit-modal-item-empty" class="edit-modal__content-wrap d-none">
    <div class="edit-modal__content-body">

      <div class="edit-modal__empty">
        <div class="edit-modal__empty-copy">
          <h4>Select an item to get started</h4>
          <p>Make all your changes in one go. When you’re done making changes, hit the ‘Review changes’ button.</p>
        </div>
        <div class="edit-modal__empty-img">
          <img src="/assets/img/home/header-shop-personal-greyscale.svg" alt="" class="img-fluid">
        </div>
      </div>


    </div>
  </div>

  <div id="item-overview-policyholder-details" class="edit-modal__content-wrap d-none">

    <div class="edit-modal__content-header">

      <div class="edit-modal__back">
        <button class="edit-modal__back-arrow" (click)="switchEditModalState('items-active')">
          <svg class="icon">
            <use xlink:href="#arrow-left-small"></use>
          </svg>
        </button>
        <div class="edit-modal__back-title">
          <strong>
            Policy overview
          </strong>
        </div>
      </div>


    </div>

    <div class="edit-modal__content-body">

      <div class="p-20">

        <div class="card card--edit-modal">
          <div class="card-body">
            <div class="card__content">

              <app-question-textbox [showLabel]="true" [labelText]="'First Name'"
                [placeHolderText]="'First Name (required)'" [value]="item?.person[0]?.first_name"
                (questionAnswer)="updateProfile($event, 'First Name')">
              </app-question-textbox>



              <app-question-textbox [showLabel]="true" [labelText]="'Last Name'"
                [placeHolderText]="'Last Name (required)'" [value]="item?.person[0]?.last_name"
                (questionAnswer)="updateProfile($event, 'Last Name')">
              </app-question-textbox>



              <app-question-email [showLabel]="true"
                [question]="{cent_aq_question_id: 0, answer: item?.person[0]?.email, question_prompt: 'Email Address', email_version:'Email Address'}"
                [inputType]="'email'" [labelText]="'Email Address'"
                [placeHolderText]="'Email Address (required)'" [value]="item?.person[0]?.email"
                (questionAnswer)="updateProfile($event, 'Email')">
              </app-question-email>



              <app-question-textbox [showLabel]="true" [labelText]="'Mobile Number'"
                [placeHolderText]="'Mobile Number (required)'" [value]="item?.person[0]?.mobile"
                (questionAnswer)="updateProfile($event, 'Mobile')">
              </app-question-textbox>



              <app-question-textbox [showLabel]="true"
                [labelText]="item?.person[0]?.id_no ? 'ID Number' : 'Passport Number'"
                [placeHolderText]="item?.person[0]?.id_no ? 'ID Number (required)' : 'Passport Number (required)'"
                [readOnly]="true" [showToolTip]="true" [isToolTipContentHtml]="true"
                [toolTipContent]="'<div class=\'popover__content\'>If you would like to change your ID Number, please chat to us <a href=\'javascript:;\'>here</a> or contact us directly at <strong>087 095 2823</strong>.</div>'"
                [value]="item?.person[0]?.id_no ? item?.person[0]?.id_no : item?.person[0]?.passport_no">
              </app-question-textbox>

              <app-question-date-of-birth [value]="item?.person[0]?.dob" [showLabel]="true"
                [labelText]="'Birthday'" [readOnly]="true" (questionAnswer)="updateProfile($event, 'Birthday')">
              </app-question-date-of-birth>

              <app-question-address-textbox [showLabel]="true" [labelText]="'Main Address'"
                [address]="item?.person[0]?.address" (questionAnswer)="updateProfile($event, 'Address')">
              </app-question-address-textbox>


              @if (item?.person[0]?.policy_inception_date?.inception_date) {
                <app-question-date-picker [numberMonths]="1"
                  [initialDate]="item?.person[0]?.policy_inception_date?.inception_date"
                  [minDate]="item?.person[0]?.policy_inception_date?.inception_date_min"
                  [maxDate]="item?.person[0]?.policy_inception_date?.inception_date_max" [showIcon]="true"
                  [showLabel]="true" [controlLabel]="'Inception date'"
                  (questionAnswer)="updateInceptionDate($event)" [showIcon]="true">
                </app-question-date-picker>
              }



              <!-- <div class="form-group" id="tpq-warning-field">
              <label>Lorem ipsum dolor sit amet?</label>
              <input type="text" value="Aenean luctus" placeholder="" class="form-control">
              <div class="notice mt-15" style="display:none;">
                <div class="notice__content">
                  <svg class="icon"><use xlink:href="#warning"></use></svg>
                  <p>You’ve made a change to this answer</p>
                </div>
                <a href="#" class="button-control" id="tpq-warning-field-undo"><strong>Undo</strong></a>
              </div>
            </div> -->
          </div>
        </div>
      </div>



    </div>

  </div>

</div>

<div id="item-overview-payment-details" class="edit-modal__content-wrap d-none">

  <div class="edit-modal__content-header">

    <div class="edit-modal__back">
      <button class="edit-modal__back-arrow" (click)="switchEditModalState('items-active')">
        <svg class="icon">
          <use xlink:href="#arrow-left-small"></use>
        </svg>
      </button>
      <div class="edit-modal__back-title">
        <strong>
          Policy overview
        </strong>
      </div>
    </div>


  </div>

  <div class="edit-modal__content-body">

    <div class="p-20">

      <div class="card card--edit-modal">
        <div class="card-body">
          <div class="card__content">
            @if (item?.bank_details?.acc_no === '') {
              <p>
                No payment details provided.
              </p>
            }
            @if (item?.bank_details?.acc_no) {
              <img src="assets/icn/bank.svg" class="data-item-cc__icon">
            }
            @if (item?.bank_details?.acc_no) {
              <div class="data-item-cc__content">
                {{item?.bank_details?.bank_name}}
                <br>
                  <small class="text-color-grey-6">{{item?.bank_details?.acc_no}}</small>
                </div>
              }
              <!-- <div class="form-group" id="tpq-warning-field">
              <label>Lorem ipsum dolor sit amet?</label>
              <input type="text" value="Aenean luctus" placeholder="" class="form-control">
              <div class="notice mt-15" style="display:none;">
                <div class="notice__content">
                  <svg class="icon"><use xlink:href="#warning"></use></svg>
                  <p>You’ve made a change to this answer</p>
                </div>
                <a href="#" class="button-control" id="tpq-warning-field-undo"><strong>Undo</strong></a>
              </div>

            </div> -->
          </div>
        </div>
      </div>

      <!-- <div class="card card--edit-modal">
      <div class="card-body">
        <div class="card__content">


          <div class="form-group">
            <label>Multi-select option example</label>

            <label class="custom-input custom-input--checkbox">
              <input type="checkbox" name="checkbox-example-3">
              <span class="custom-input__indi"></span>
              <span class="custom-input__label">Monitored electric fencing</span>
            </label>

            <label class="custom-input custom-input--checkbox">
              <input type="checkbox" data-type="exclusive" name="checkbox-example-4">
              <span class="custom-input__indi"></span>
              <span class="custom-input__label">None of the above</span>
            </label>
          </div>
        </div>
      </div>
    </div> -->

  </div>

</div>

</div>

<div id="item-insured-items" class="edit-modal__content-wrap d-none">
  <div class="edit-modal__content-header">

    <div class="edit-modal__back">
      <button class="edit-modal__back-arrow" (click)="switchEditModalState('items-active')">
        <svg class="icon">
          <use xlink:href="#arrow-left-small"></use>
        </svg>
      </button>
      <div class="edit-modal__back-title">
        <strong>
          Insured item
        </strong>
      </div>
    </div>

  </div>




  <div class="edit-modal__content-body">

    <div class="p-20 pt-0 pt-md-20">

      <div class="summary-card">
        <div class="summary-card__header">
          <!-- <div class="summary-card__header-tag">
          <span class="tag-pill tag-pill--positive tag-pill--inverted">Added</span>
        </div> -->
        <div class="summary-card__header-title">
          <h3>{{ getDescription(0,selectedItem?.description_1) ?
          getDescription(0,selectedItem?.description_1) : selectedItem?.answer }}</h3>
          <p>{{selectedItem?.description_2}}</p>
        </div>
        @if (selectedItem?.prem_value) {
          <div class="summary-card__header-cost">
            <p><strong><em>{{accounting?.formatMoney(selectedItem?.prem_value)}}</em></strong>
          /{{item?.frequency_short}}</p>
        </div>
      }
    </div>
    <div class="summary-card__actions">

      @if (!selectedItem?.del) {
        <a href="javascript:;" data-toggle="modal" (click)="cancelCover(Entities.Item)"
          class="action-icon action-icon--transparent">
          <div class="action-icon__icon">
            <svg class="icon">
              <use xlink:href="#trash-bin"></use>
            </svg>
          </div>
          <small class="action-icon__label">Remove</small>
        </a>
      }

    </div>
  </div>

  @for (question of selectedtQuestions; track question.cent_aq_question_id) {
    <div class="card card--edit-modal active-question-{{question.cent_aq_question_id}}"
      >
      <div class="card-body">
        <div class="card__content">
          <!-- <div class="card__header">
          <div class="card__header-title">
            <h5>{{question?.email_version}}</h5>
          </div>
        </div> -->
        <app-question-controller [question]="question" [showLabel]="true" [showParent]="false"
          [isEditModal]="true" [readOnly]="false" [showLabelEmailVersion]="true"
          (questionAnswer)="questionResponse($event)" [controlCssClass]="' '">
        </app-question-controller>
        <!-- <div class="form-group">
        <input type="text" value="Aenean luctus" placeholder="" class="form-control">
      </div> -->
    </div>
    <div class="card__additional {{question?.cent_aq_question_id}} d-none"
      id="demo-additional-questions-container">
      <div class="card__additional-wrap"
        id="demo-additional-questions-{{question?.cent_aq_question_id}}">
        <div class="card__additional-inner" id="demo-additional-questions">
          @if (currentQuestion?.flow_index === 1) {
            <div class="question-heading">
              <div class="question-heading__avatar question-heading__avatar--centered">
                <img src="/assets/{{item?.category_id}}/avatar/happy.png" class="img-fluid" alt="">
              </div>
              <div class="question-heading__content">
                <h3 class="h5"><strong>We have a few more questions</strong></h3>
              </div>
            </div>
          }
          <div class="question">
            <div class="question__title">
              {{currentQuestion?.email_version}}
            </div>
            <div class="form-group">
              <app-question-controller [question]="currentQuestion" [showLabel]="false"
                [showParent]="false" [isEditModal]="true" [readOnly]="false"
                [childItemQuestions]="getChildrenQuestions(currentQuestion)"
                [showLabelEmailVersion]="false" (questionAnswer)="subQuestionResponse($event)">
              </app-question-controller>
            </div>
            @if (currentQuestion?.itk) {
              <aside class="question-fyi">
                <div class="question-fyi__icon">
                  <img src="assets/0/icn/message-avatar.svg" class="icon">
                </div>
                <div class="question-fyi__content">
                  <h6>Important to know</h6>
                  <p [innerHTML]="itk"></p>
                </div>
              </aside>
            }
          </div>
        </div>
        <!-- <div class="card__additional-inner" id="demo-additional-questions-q2">
        <div class="question">
          <div class="question__title">
            Has an insurer ever cancelled or refused them cover on their car insurance?
          </div>
          <div class="form-group">
            <label class="custom-input custom-input--lg custom-input--radio">
              <input type="radio" checked name="refused-1">
              <span class="custom-input__indi"></span>
              <span class="custom-input__label">Yes</span>
            </label>
            <label class="custom-input custom-input--lg custom-input--radio">
              <input type="radio" name="refused-1">
              <span class="custom-input__indi"></span>
              <span class="custom-input__label">No</span>
            </label>
          </div>
          <aside class="question-fyi">
            <div class="question-fyi__icon">
              <img src="/assets/0/icn/message-avatar.svg" class="icon">
            </div>
            <div class="question-fyi__content">
              <h6>Important to know</h6>
              <p>It is very important that you include the exact name/(s) of the insured party/(ies)</p>
            </div>
          </aside>
        </div>
      </div>
      <div class="card__additional-inner" id="demo-additional-questions-q3">
        <div class="question">
          <div class="question__title">
            Dependant on the answer to the previous question, please provide the reason for the cancellation or refusal.
          </div>
          <div class="form-group">
            <label class="custom-input custom-input--lg custom-input--radio">
              <input type="radio" checked name="refused-why-1">
              <span class="custom-input__indi"></span>
              <span class="custom-input__label">Non-disclousure</span>
            </label>
            <label class="custom-input custom-input--lg custom-input--radio">
              <input type="radio" name="refused-why-1">
              <span class="custom-input__indi"></span>
              <span class="custom-input__label">Credit history</span>
            </label>
          </div>
        </div>
      </div> -->
      <div class="card__additional-nav">
        @if (!(currentQuestion?.flow_index === 1) || !currentQuestion?.next) {
          <a href="javascript:;" (click)="prevQuestion()"
          class="button button--no-min button--naked" id="additional-questions-back-btn">Back</a>
        }
        @if (currentQuestion?.next) {
          <button (click)="nextQuestion()" class="button button--primary"
            [ngClass]="{'button--loading': processing}" [disabled]="processing"
            id="additional-questions-continue-btn">
            @if (processing) {
              <span class="button__spinner"><span class="spinner"></span></span>
            }
            Continue
          </button>
        }
        @if (!currentQuestion?.next) {
          <button (click)="dependantFlowDone()"
            class="button button--primary" [ngClass]="{'button--loading': processing}"
            [disabled]="processing" id="additional-questions-continue-btn">
            @if (processing) {
              <span class="button__spinner"><span class="spinner"></span></span>
            }
            Done
          </button>
        }
      </div>
    </div>
    <div class="card__additional-wrap d-none"
      id="demo-additional-summary-{{question?.cent_aq_question_id}}">
      <div class="card__additional-summary">
        @for (answeredQuestion of answeredQuestions; track answeredQuestion) {
          <div class="card__additional-summary-control"
            >
            <div class="card__header">
              <div class="card__header-title">
                <h5>{{answeredQuestion?.email_version}}</h5>
              </div>
            </div>
            <div class="form-group">
              <app-question-controller [question]="answeredQuestion" [showLabel]="false"
                [showParent]="false" [isEditModal]="true" [readOnly]="false"
                [childItemQuestions]="getChildrenQuestions(answeredQuestion)"
                [showLabelEmailVersion]="false">
              </app-question-controller>
            </div>
          </div>
        }
      </div>
      <div class="card__additional-nav">
        <a href="javascritp:;" (click)="restartFlow()" class="button button--no-min button--naked"
        id="additional-questions-edit-btn">Edit answers</a>
      </div>
    </div>
  </div>
</div>
</div>
}

</div>

</div>
</div>

<div id="item-benefits" class="edit-modal__content-wrap d-none">
  <div class="edit-modal__content-header">

    <div class="edit-modal__back">
      <button class="edit-modal__back-arrow" (click)="switchEditModalState('items-active')">
        <svg class="icon">
          <use xlink:href="#arrow-left-small"></use>
        </svg>
      </button>
      <div class="edit-modal__back-title">
        <strong>
          Policy benefit
        </strong>
      </div>
    </div>


  </div>
  <div class="edit-modal__content-body">

    <div class="p-20 pt-0 pt-md-20">
      <div class="edit-modal__content-body-contain">
        <div class="summary-card">
          <div class="summary-card__header">
            <div class="summary-card__header-tag">
              <span class="tag-pill tag-pill--positive tag-pill--inverted">{{selectedItem?.entry_type ==
                "addon" ?
              'Added' : 'Included'}}</span>
            </div>
            @if (selectedItem?.entry_type == 'addon' ) {
              <div class="summary-card__header-title">
                @if (selectedItem?.vaps?.length && selectedItem.vaps[0]?.pv?.length) {
                  <h3>
                  {{selectedItem?.vaps[0]?.pv[0].vaps_name}}</h3>
                }
                @if (selectedItem?.vaps?.length && selectedItem.vaps[0]?.pv?.length) {
                  <p>
                  {{selectedItem?.vaps[0]?.pv[0].vaps_description}}</p>
                }
              </div>
            }
            @if (!selectedItem?.entry_type) {
              <div class="summary-card__header-title">
                <h3>{{selectedItem?.vaps_name}}</h3>
                <p>{{selectedItem?.vaps_description}}</p>
              </div>
            }
            @if (selectedItem?.entry_type == 'addon' ) {
              <div class="summary-card__header-cost">
                <p><strong><em>{{accounting?.formatMoney(selectedItem?.prem_value)}}</em></strong>
              /{{item?.frequency_short}}</p>
              <!-- <span class="tag tag--sm tag--deal text-color-white">
              <svg class="icon">
                <use xlink:href="#deal-verified"></use>
              </svg>
              Best Deal
            </span>                         -->
          </div>
        }
      </div>
      @if (selectedItem?.entry_type == 'addon' ) {
        <div class="summary-card__actions">
          <!-- <a href="javascript:;" (click)="cancelCover(Entities.Vap,null,selectedItem)"  class="action-icon action-icon--transparent">
          <div class="action-icon__icon">
            <svg class="icon">
              <use xlink:href="#trash-bin"></use>
            </svg>
          </div>
          <small class="action-icon__label">Remove</small>
        </a> -->
      </div>
    }
  </div>

  @for (benefit of selectedItem?.vaps; track benefit) {
    <div class="edit-modal__benefit">
      <div class="edit-modal__benefit-heading">
        <div class="edit-modal__benefit-title">
          <h5>{{getDescription(0,benefit?.detail)}}</h5>
          <p class="text-color-grey-6"><small>{{getDescription(1,benefit?.detail)}}</small></p>
        </div>
        <div class="edit-modal__benefit-price">
          <p class="price price--sm"><strong>{{accounting?.formatMoney(benefit?.premium)}}</strong>
        /{{item?.frequency_short}}</p>
      </div>
    </div>
    <div class="edit-modal__benefit-actions">
      <div class="actions">
        <!-- <a href="#pause-alert-modal" data-toggle="modal" class="action-icon">
        <div class="action-icon__icon">
          <svg class="icon">
            <use xlink:href="#pause"></use>
          </svg>
        </div>
        <small class="action-icon__label">Pause</small>
      </a> -->
      <a href="javascript:;" (click)="cancelCover(Entities.Vap,null,benefit)" class="action-icon">
        <div class="action-icon__icon">
          <svg class="icon">
            <use xlink:href="#trash-bin"></use>
          </svg>
        </div>
        <small class="action-icon__label">Remove</small>
      </a>
    </div>
  </div>
</div>
}
@for (benefit of selectedItem?.items; track benefit) {
  <div class="edit-modal__benefit">
    <div class="edit-modal__benefit-heading">
      <div class="edit-modal__benefit-title">
        <h5>{{getDescription(0,benefit?.detail)}}</h5>
        <p class="text-color-grey-6"><small>{{getDescription(1,benefit?.detail)}}</small></p>
      </div>
      <div class="edit-modal__benefit-price">
        <p class="price price--sm"><strong>{{accounting?.formatMoney(benefit?.premium)}}</strong>
      /{{item?.frequency_short}}</p>
    </div>
  </div>
</div>
}
</div>

</div>



</div>
</div>

</div>
</div>

<div class="edit-modal__review d-none" id="edit-modal-review-demo">
  <div class="edit-modal__review-col">
    <!-- hidden on mobile & tablet -->

    <div class="edit-modal__review-body">

      <div class="pt-10 pb-10">

        <div class="edit-modal__menu">

          <nav class="edit-nav">
            <ul>
              @if (policyHolder?.length > 0) {
                <li class="has-sub is-active">
                  <a href="javascript:;">
                    <p><span>Overview</span></p>
                  </a>
                  <div>
                    <ul>
                      <li>
                        <a href="javascritp:;" (click)="scrollTo(policyHolder[0]?.class_id)">Policyholder details</a>
                      </li>
                    </ul>
                  </div>
                </li>
              }
              @if (changeItems?.length > 0) {
                <li class="has-sub is-active">
                  <a href="javascript:;">
                    <p><span>Insured items</span></p>
                  </a>
                  <div>
                    <ul>
                      @for (change of changeItems; track change) {
                        <li>
                          <a href="javascritp:;" (click)="scrollTo(change?.class_id)">{{change?.class_name}}</a>
                        </li>
                      }
                    </ul>
                  </div>
                </li>
              }
              @if (changeBenefits?.length) {
                <li class="has-sub is-active">
                  <a href="javascript:;">
                    <p><span>Benefits</span></p>
                  </a>
                  <div>
                    <ul>
                      @for (change of changeBenefits; track change) {
                        <li>
                          <a href="javascritp:;" (click)="scrollTo(change?.class_id)">{{change?.class_name}}</a>
                        </li>
                      }
                    </ul>
                  </div>
                </li>
              }
            </ul>
          </nav>


        </div>

      </div>

    </div>
  </div>
  <div class="edit-modal__review-col">
    <div class="edit-modal__review-body">

      <div class="pb-20 p-md-25 p-xl-30 pl-xl-0">

        <div class="mb-md-20" id="edit-modal-review-notice-demo">
          <app-highlight-message
            variant="warning"
            icon="warning"
            message="Any changes you make will take effect from today once confirmed."
            additionalClasses="notice--mobile-flush">
          </app-highlight-message>
        </div>

        <div class="pl-20 pr-20 p-md-0">

          <div class="summary-card summary-card--review">
            <div class="summary-card__header">
              <div class="summary-card__header-title">
                <h3>{{changeProduct?.product_name}}</h3>
              </div>
              <div class="summary-card__header-cost">
                <p><s><strong><em>{{changeProduct?.curr_prem_value}}</em></strong> /{{changeProduct?.curr_freq_short}}</s></p>
                <p><strong><em>{{changeProduct?.new_prem_value}}</em></strong> /{{changeProduct?.new_freq_short}}</p>
              </div>
            </div>

          </div>

          <div class="edit-summary">
            @if (policyHolder?.length > 0) {
              <div class="edit-summary__category">
                <div class="edit-summary__heading">
                  <h4>Policyholder details</h4>
                </div>
                <div class="edit-summary__type" [id]="0" >
                  <div class="edit-summary__title">
                    <h5>General</h5>
                  </div>
                  <div class="edit-summary__list">
                    @for (item of policyHolder; track item) {
                      <div class="edit-summary-item">
                        <div class="edit-summary-item__content">
                          <div class="edit-summary-item__title">
                            <h6 class="font-16">{{getDescription(0,item?.description_1)}}</h6>
                            <p><small>{{item?.description_2}}</small></p>
                          </div>
                          <div class="edit-summary-item__summary">
                            <ul class="icon-list-custom icon-list-custom--md">
                              @if (item?.status_id === 1 && !item?.end_date) {
                                <li>
                                  <svg class="icon text-color-info">
                                    <use xlink:href="#refresh"></use>
                                  </svg>
                                  <p>Cover on this item has been updated</p>
                                </li>
                              }
                              @if (item?.status_id === 1 && item?.end_date) {
                                <li>
                                  <svg class="icon text-color-positive">
                                    <use xlink:href="#add-items"></use>
                                  </svg>
                                  <p>Item will be included in your cover from {{item?.effective_date}}</p>
                                </li>
                              }
                              <!-- <li *ngIf="item?.status_id === 2">
                              <svg class="icon text-color-grey-6">
                                <use xlink:href="#pause"></use>
                              </svg>
                              <p>Cover on this item will be paused from [date] - [date]</p>
                            </li> -->
                            @if (item?.status_id === 4) {
                              <li>
                                <svg class="icon text-color-error">
                                  <use xlink:href="#cancelled"></use>
                                </svg>
                                <p>Cover on this item has been cancelled</p>
                              </li>
                            }
                            @if (item?.uw_flag === 1) {
                              @for (uw of item?.uw_collation; track uw) {
                                <li>
                                  <svg class="icon text-color-grey-6">
                                    <use xlink:href="#info"></use>
                                  </svg>
                                  <p>{{uw?.Condition_Name}}</p>
                                </li>
                              }
                            }
                          </ul>
                        </div>
                      </div>
                      <div class="edit-summary-item__meta">
                        @if (item?.curr_prem_value) {
                          <div class="edit-summary-item__cost">
                            <p class="price"><strong><em>{{item?.new_prem_value}}</em></strong>/{{item?.new_freq_short}}</p>
                            @if (item?.curr_prem_value) {
                              <p class="price price--strikeout">
                                <strong><em>{{item?.curr_prem_value}}</em></strong>/{{item?.curr_freq_short}}</p>
                              }
                            </div>
                          }
                          <!-- <div  class="edit-summary-item__actions">
                          <button data-target="#review-remove-modal" data-toggle="modal" class="edit-summary-item__action">
                            <svg class="icon">
                              <use xlink:href="#trash-bin"></use>
                            </svg>
                          </button>
                        </div> -->
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
          @if (changeItems?.length > 0) {
            <div class="edit-summary__category">
              <div class="edit-summary__heading">
                <h4>Insured items</h4>
              </div>
              @for (change of changeItems; track change) {
                <div class="edit-summary__type" [id]="change?.class_id">
                  <div class="edit-summary__title">
                    <h5>{{change?.class_name}}</h5>
                  </div>
                  <div class="edit-summary__list">
                    @for (item of change?.items; track item) {
                      <div class="edit-summary-item">
                        <div class="edit-summary-item__content">
                          <div class="edit-summary-item__title">
                            <h6 class="font-16">{{getDescription(0,item?.description_1)}}</h6>
                            <p><small>{{item?.description_2}}</small></p>
                          </div>
                          <div class="edit-summary-item__summary">
                            <ul class="icon-list-custom icon-list-custom--md">
                              @if (item?.status_id === 1 && !item?.end_date) {
                                <li>
                                  <svg class="icon text-color-info">
                                    <use xlink:href="#refresh"></use>
                                  </svg>
                                  <p >Cover on this item has been updated</p>
                                </li>
                              }
                              @if (item?.status_id === 1 && item?.end_date) {
                                <li>
                                  <svg class="icon text-color-positive">
                                    <use xlink:href="#add-items"></use>
                                  </svg>
                                  <p >Item will be included in your cover from {{item?.effective_date}}</p>
                                </li>
                              }
                              <!-- <li *ngIf="item?.status_id === 2">
                              <svg class="icon text-color-grey-6">
                                <use xlink:href="#pause"></use>
                              </svg>
                              <p>Cover on this item will be paused from [date] - [date]</p>
                            </li>   -->
                            @if (item?.status_id === 4) {
                              <li>
                                <svg class="icon text-color-error">
                                  <use xlink:href="#cancelled"></use>
                                </svg>
                                <p>Cover on this item has been cancelled</p>
                              </li>
                            }
                            @if (item?.uw_flag === 1) {
                              @for (uw of item?.uw_collation; track uw) {
                                <li>
                                  <svg class="icon text-color-grey-6">
                                    <use xlink:href="#info"></use>
                                  </svg>
                                  <p>{{uw?.Condition_Name}}</p>
                                </li>
                              }
                            }
                          </ul>
                        </div>
                      </div>
                      <div class="edit-summary-item__meta">
                        <div class="edit-summary-item__cost">
                          <p class="price"><strong><em>{{item?.new_prem_value}}</em></strong>/{{item?.new_freq_short}}</p>
                          @if (item?.curr_prem_value) {
                            <p class="price price--strikeout"><strong><em>{{item?.curr_prem_value}}</em></strong>/{{item?.curr_freq_short}}</p>
                          }
                        </div>
                        <!-- <div  class="edit-summary-item__actions">
                        <button data-target="#review-remove-modal" data-toggle="modal" class="edit-summary-item__action">
                          <svg class="icon">
                            <use xlink:href="#trash-bin"></use>
                          </svg>
                        </button>
                      </div> -->
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }

      @if (changeBenefits?.length) {
        <div class="edit-summary__category">
          <div class="edit-summary__heading">
            <h4>Benefits</h4>
          </div>
          @for (change of changeBenefits; track change) {
            <div class="edit-summary__type" [id]="change?.class_id">
              <div class="edit-summary__title">
                <h5>{{change?.class_name}}</h5>
              </div>
              <div class="edit-summary__list">
                @for (item of change?.items; track item) {
                  <div class="edit-summary-item">
                    <div class="edit-summary-item__content">
                      <div class="edit-summary-item__title">
                        <h6 class="font-16"> {{item?.vaps_name}}</h6>
                        <p class="mt-20"><strong>{{getDescription(0,item?.description_1)}} {{getDescription(1,item?.description_1)}}</strong></p>
                        <p>{{getDescription(2,item?.description_1)}}</p>
                      </div>
                      <div class="edit-summary-item__summary">
                        <ul class="icon-list-custom icon-list-custom--md">
                          @if (item?.status_id === 1 && !item?.end_date) {
                            <li>
                              <svg class="icon text-color-info">
                                <use xlink:href="#refresh"></use>
                              </svg>
                              <p >Cover on this item has been updated</p>
                            </li>
                          }
                          @if (item?.status_id === 1 && item?.end_date) {
                            <li>
                              <svg class="icon text-color-positive">
                                <use xlink:href="#add-items"></use>
                              </svg>
                              <p >Item will be included in your cover from {{item?.effective_date}}</p>
                            </li>
                          }
                          @if (item?.status_id === 2) {
                            <li>
                              <svg class="icon text-color-grey-6">
                                <use xlink:href="#add-items"></use>
                              </svg>
                              <p>{{item?.description_2}}</p>
                            </li>
                          }
                          @if (item?.status_id === 3) {
                            <li>
                              <svg class="icon text-color-error">
                                <use xlink:href="#cancelled"></use>
                              </svg>
                              <p>{{item?.description_2}}</p>
                            </li>
                          }
                          @if (item?.uw_flag === 1) {
                            @for (uw of item?.uw_collation; track uw) {
                              <li>
                                <svg class="icon text-color-grey-6">
                                  <use xlink:href="#info"></use>
                                </svg>
                                <p>{{uw?.Condition_Name}}</p>
                              </li>
                            }
                          }
                        </ul>
                      </div>
                    </div>
                    <div class="edit-summary-item__meta">
                      <div class="edit-summary-item__cost">
                        <p class="price"><strong><em>{{item?.new_prem_value}}</em></strong>/{{item?.new_freq_short}}</p>
                        @if (item?.curr_prem_value) {
                          <p class="price price--strikeout"><strong><em>{{item?.curr_prem_value}}</em></strong>/{{item?.curr_freq_short}}</p>
                        }
                      </div>
                      <div class="edit-summary-item__actions">
                        <!-- <button class="edit-summary-item__action">
                        <svg class="icon">
                          <use xlink:href="#trash-bin"></use>
                        </svg>
                      </button> -->
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }


  </div>

  @if (false) {
    <div class="edit-summary edit-summary--itk">
      <div class="edit-summary__type">
        <div class="edit-summary__title">
          <h5>Important to know</h5>
        </div>
        <div class="edit-summary__list">
          <div class="edit-summary-item edit-summary-item--itk">
            <div class="edit-summary-item__content">
              <div class="edit-summary-item__title">
                <p class="mb-10"><strong>Pro rata cost</strong></p>
                <p><small>14 May 2021 - 31 May 2021</small></p>
              </div>
            </div>
            <div class="edit-summary-item__meta">
              <div class="edit-summary-item__cost">
                <p class="price price--sm"><strong><em>R 300</em>.00</strong>/mo</p>
              </div>
            </div>
          </div>
        </div>
        <div class="rte mt-20">
          <ul>
            <li>By clicking "Confirm" you confirm that you agree to the Terms and Conditions, Professional Fee and Policy Wording.</li>
            <li>You will only be covered for the changes you made to the renewed policy once it takes effect.</li>
            <li>Note that the items that you've added, paused or cancelled will take effect on the dates as specified by you.</li>
          </ul>
        </div>
      </div>
    </div>
  }


  <div class="mt-25 text-center">
    <a href="javascript:;" (click)="submitPolicyChanges()" class="button button--lg button--primary" id="confirm-changes-demo-btn">Confirm changes</a>
  </div>


</div>

</div>


</div>
</div>
</div>
<div class="edit-modal__uw d-none" id="edit-modal-uw-demo">
  <div class="edit-modal__uw-body">

    <div class="container layout layout--questions">
      <div class="layout__main">
        <div class="question-heading">
          <div class="question-heading__avatar">
            <img src="/assets/3/avatar/happy.png" class="img-fluid" alt="">
          </div>
          <div class="question-heading__content">
            <h3>Some of your items require special attention.</h3>
            <p>Some of your changes can’t be confirmed just yet and require special attention from our underwriting team. We’ll be in touch with next steps and follow-up questions where required.</p>
          </div>
        </div>
        <!-- /.question-heading -->

        <div class="question">
          @for (group of uw_collation | keyvalue; track group) {
            <div>
              <div class="question-pull">
                @if (checkUW3(group.value)) {
                  <p class="mb-20">{{ group.key }}</p>
                }
                @for (item of group.value; track item) {
                  @if (item?.uw_action_id == 3) {
                    <div class="question-card" >
                      @if (item?.uw_action_id == 3) {
                        <div class="question-card__item">
                          <p class="mb-20"> {{ getDescription(0,changeProduct?.description_1) }}</p>
                          <app-highlight-message
                            [hideIcon]="true"
                            [message]="item.Condition_Description">
                          </app-highlight-message>
                        </div>
                      }
                    </div>
                  }
                }
              </div>
            </div>
          }
          @for (group of changeItems; track group) {
            <div>
              <div class="question-pull">
                @if (checkUW3(group.items)) {
                  <p class="mt-30 mb-20">{{ group?.class_name }}</p>
                }
                @for (item of group.items; track item) {
                  @if (item?.uw_flag == 3) {
                    <div class="question-card">
                      <div class="question-card__item">
                        <p class="mb-20"> {{ getDescription(0,item?.description_1) }}, {{item?.description_2}}</p>
                        @for (uw of item.uw_collation; track uw) {
                          @if (uw?.uw_action_id == 3) {
                            <app-highlight-message
                              [hideIcon]="true"
                              [message]="uw?.Condition_Description">
                            </app-highlight-message>
                          }
                        }
                      </div>
                    </div>
                  }
                }
              </div>
            </div>
          }

        </div>
      </div>
    </div>

  </div>
</div>
<div class="edit-modal__tray" id="edit-modal-changes-tray-demo" [class.d-none]="!changesTrayVisible">
  <!-- <div class="edit-modal__tray-btn">
  <a href="javascript:;" (click)="reviewCommit()" class="button button--block button--primary" id="review-and-commit-demo-btn">Review and commit</a>
</div> -->
<div class="edit-modal__tray-btn">
  <a href="#discard-changes-modal" data-toggle="modal" class="button button--block button--secondary">Discard
  changes</a>
  <a href="javascript:;" (click)="reviewCommit()"  class="button button--block button--primary" id="review-and-commit-demo-btn">Review changes</a>
</div>
</div>
<div class="edit-modal__tray d-none" id="edit-modal-uw-tray-demo">
  <div class="edit-modal__tray-btn">
    <a href="javascript:;" (click)="closeEditModal()" data-dismiss="edit-modal" class="button button--block button--primary" id="return-to-policy-demo-btn">Return to your policy</a>
  </div>
</div>



</div>
</div>

<div class="edit-modal__backdrop"></div>
</div>
<app-pause-policy
  #pausePolicyComponent
  [frequency_id]="frequency_id"
  [policy]="item"
  [isEditPolicyPage]="true"
  (getNewDataEdit)="onPolicyChange($event)">
</app-pause-policy>

<!-- Cancel Policy Modal -->
<app-cancel-policy
  #cancelPolicyComponent
  [frequency_id]="frequency_id"
  [policy]="item"
  [isEditPolicyPage]="true"
  (pauseModal)="openPauseCoverFromCancel($event)"
  (getNewDataEdit)="onPolicyChange($event)">
</app-cancel-policy>

<!-- Resume Policy Modal -->
<app-resume-policy
  #resumePolicyComponent
  [policy]="item"
  [frequency_id]="frequency_id"
  [isEditPolicyPage]="true"
  (getNewDataEdit)="onPolicyChange($event)">
</app-resume-policy>

<!-- Restore Policy Modal -->
<app-restore-policy
  #restorePolicyComponent
  [frequency_id]="frequency_id"
  [policy]="item"
  [isEditPolicyPage]="true"
  (getNewDataEdit)="onPolicyChange($event)">
</app-restore-policy>
<div class="modal fade modal--mini " id="discard-changes-modal" tabindex="-1" aria-labelledby="discard-changes-modal" aria-modal="true" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-mini">
      <div class="modal-mini__heading">
        <div class="container-fluid">
          <h4>Are you sure you want to discard your changes?</h4>
        </div>
      </div>

      <div class="modal-mini__content">
        <div class="container-fluid">
          <div class="rte">
            <p>By continuing, all of your changes to this policy will be discarded. Once gone, these changes
            till not be recoverable.</p>

            <p>Are you sure you want to continue?</p>
          </div>
        </div>
      </div>

      <div class="modal-mini__button">
        <div class="container-fluid">
          <!-- this should undo any any changes -->
          <a href="#" data-dismiss="modal" class="button button--secondary">Go back</a>
          <a href="javascript:;" (click)="discardChanges()" data-dismiss="modal" class="button button--primary" id="demo-discard-changes-trigger">Discard changes</a>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="guide guide--attached-top-right" id="guide-1-tip-1" data-target="#discard-changes-modal-trigger">
  <div class="guide__close">
    <svg class="icon">
      <use xlink:href="#close-circle-small"></use>
    </svg>
  </div>
  <div class="guide__content">
    <p>Remove these changes</p>
    <div class="rte">
      <p>Tap here to discard all of the changes you've made to this item. Once they're gone, they won't be
      recoverable.</p>
    </div>
  </div>
  <div class="guide__tray">
    <div class="guide__progress">1 / 2</div>
    <div class="guide__btn">
      <a href="#guide-1-tip-2" data-guide-btn="next" class="button button--sm button--everything">Next</a>
    </div>
  </div>
</div>

<div class="guide guide--attached-btm-center" id="guide-1-tip-2" data-target="#review-and-commit-demo-btn">
  <div class="guide__close">
    <svg class="icon">
      <use xlink:href="#close-circle-small"></use>
    </svg>
  </div>
  <div class="guide__content">
    <p>Happy with all of your changes?</p>
    <div class="rte">
      <p>Once you've made all of your changes to this policy, your insured items and added benefits, tap here to
      review and update your policy.</p>
    </div>
  </div>
  <div class="guide__tray">
    <div class="guide__progress">2 / 2</div>
    <div class="guide__btn">
      <a href="#" data-guide-btn="end" class="button button--sm button--everything">Got it</a>
    </div>
  </div>
</div>

<div class="modal fade modal--mini" id="remove-insured-select-modal" tabindex="-1" aria-labelledby="remove-insured-select-modal" aria-modal="true" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-mini">
      <div class="modal-mini__heading">
        <div class="container-fluid">
          <h4>Remove an item</h4>
        </div>
      </div>

      <div class="modal-mini__content">
        <div class="container-fluid">
          <div class="custom-input__desktop-scroller">
            @for (class of classes; track class) {
              @if (getClassItems(class?.class_id)?.length > 0) {
                <h5 class=" mt-30 mb-20">{{class.description_1}}</h5>
              }
              @for (item of getClassItems(class?.class_id); track item) {
                <label class="custom-input custom-input--radio custom-input--vehicle">
                  <input type="radio" (click)="selectedItem = item" name="confirm-example-1" value="1">
                  <span class="custom-input__indi"></span>
                  <span class="custom-input__label">
                    <h5 class="font-16">{{getDescription(0,item?.description_1)}}</h5>
                    <p class="helper-text">{{item?.description_2}}</p>
                  </span>
                </label>
              }
            }
          </div>

          @if (itemCount === 0) {
            <div class="custom-input__desktop-scroller">
              <p>No items to remove.</p>
            </div>
          }
        </div>
      </div>

      <div class="modal-mini__button">
        <div class="container-fluid">
          <a href="#" data-toggle="modal" data-dismiss="modal" class="button button--secondary">Cancel</a>
          <!-- should redirect to relevant question in question flow -->
          <button  [disabled]="!selectedItem?.session_item_id"  (click)="cancelCover(Entities.Item)" data-toggle="modal" data-dismiss="modal" class="button button--primary">Next</button>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade modal--mini" id="remove-benefit-select-modal" tabindex="-1" aria-labelledby="remove-benefit-select-modal" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-mini">
      <div class="modal-mini__heading">
        <div class="container-fluid">
          <h4>Remove a benefit</h4>
        </div>
      </div>

      <div class="modal-mini__content">
        <div class="container-fluid">
          @if (addons.length > 0) {
            <div class="custom-input__desktop-scroller">
              @for (class of getBenefitsClasses(); track class) {
                @if (hasBenefits(class?.class_id)) {
                  <h5 class="mt-30 mb-20">{{class.class_name}}</h5>
                }
                @for (addon of this.addons; track addon) {
                  @if (class?.class_id === addon?.class_id) {
                    @for (item of addon?.vaps; track item) {
                      <label class="custom-input custom-input--radio custom-input--vehicle">
                        <input type="radio" (click)="selectedItem = item" name="confirm-example-1" value="1">
                        <span class="custom-input__indi"></span>
                        <span class="custom-input__label">
                          <h5 class="font-16">{{item?.detail}}</h5>
                          <p class="helper-text">{{addon?.description_1}}</p>
                        </span>
                      </label>
                    }
                  }
                }
              }
            </div>
          }
          @if (addons.length === 0) {
            <div class="custom-input__desktop-scroller">
              <p>No benefits to remove.</p>
            </div>
          }
        </div>
      </div>

      <div class="modal-mini__button">
        <div class="container-fluid">
          <a href="#" data-toggle="modal" data-dismiss="modal" class="button button--secondary">Cancel</a>
          <button [disabled]="!selectedItem?.session_item_id" (click)="cancelCover(Entities.Vap,null,selectedItem)" data-toggle="modal" data-dismiss="modal" class="button button--primary">Next </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade modal--alert" id="inception-date-modal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false"
  aria-labelledby="activate-changes-modal" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--alt">
      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">
            <img src="assets/3/avatar/happy.png" class="img-fluid" alt=""/>
          </div>
          <!-- <button class="modal-alert__close" data-dismiss="modal">
          <svg class="icon">
            <use xlink:href="#close-medium"></use>
          </svg>
        </button> -->
      </div>
    </div>

    <div class="modal-alert__content">
      <div class="container">
        <div class="rte">
          <h3>Change Inception Date</h3>
        </div>
        <div class="note__content">
          <p>Select a new inception date for your policy.</p>
        </div>
        <hr class="hr--bdr hr--sm"/>
        <ul class="pause-summary mb-30">
          <li class="pause-summary__item pause-summary__item--total">
            <div class="pause-summary__label">
              <p>Inception Date</p>
            </div>
            <div class="pause-summary__value">
              <app-question-date-picker
                [numberMonths]="1"
                [showIcon]="true">
              </app-question-date-picker>
            </div>
          </li>
        </ul>

        <hr class="hr--bdr hr--sm"/>

        <div class="note note--naked">
          <div class="note__content">
            <h6>Important to know</h6>
            <p>Changing the inception date may affect your premium and coverage.</p>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-alert__button">
      <div class="container">
        <a href="#" class="button button--lg button--secondary" data-dismiss="modal">Cancel</a>
        <a href="javascript:;" class="button button--lg button--primary" data-dismiss="modal">Continue</a>
      </div>
    </div>
  </div>
</div>
</div>
<div class="modal fade modal--alert" id="activate-changes-modal" tabindex="-1" role="dialog"
  aria-labelledby="activate-changes-modal" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--alt">
      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">
            <img src="assets/3/avatar/happy.png" class="img-fluid" alt=""/>
          </div>
          <button class="modal-alert__close" data-dismiss="modal">
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
          </button>
        </div>
      </div>

      <div class="modal-alert__content">
        <div class="container">
          <div class="rte">
            <h3>Ready to confirm your changes?</h3>
          </div>
          @if (premiumCollation) {
            <ul class="pause-summary mb-30">
              <li class="pause-summary__item pause-summary__item--total">
                <div class="pause-summary__label">
                  <p> {{premiumCollation?.description?.length ? premiumCollation.description[0]?.bill_descr : ''}}
                    <small>{{premiumCollation?.description?.length ? premiumCollation.description[0]?.bill_dates : ''}} </small>
                  </p>
                </div>
                <div class="pause-summary__value">
                  <!--<strong>Calculating...</strong>-->
                  <strong>{{accounting?.formatMoney(premiumCollation?.description?.length ? premiumCollation.description[0]?.bill_val : 0)}}</strong>
                </div>
              </li>
            </ul>
          }

          <hr class="hr--bdr hr--sm"/>

          <div class="note note--naked">
            <div class="note__content">
              <h6>Important to know</h6>
              <ul>
                <li>
                  By clicking “Confirm” you confirm that you agree to the
                  <a href="#">Terms and Conditions, Professional Fee</a> and <a href="#">Policy Wording</a>.
                </li>
                <li>You will only be covered for the changes you made to the renewed policy once it takes effect.</li>
                <li>Note that the items that you’ve added, paused or cancelled will take effect on the dates as
                  specified by you.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-alert__button">
        <div class="container">
          <a href="#" class="button button--lg button--secondary" (click)="rollBack()" data-dismiss="modal">No, Cancel All</a>
          <a href="#" (click)="submitPolicyChanges()" class="button button--lg button--primary" data-dismiss="modal">Yes,
          Confirm</a>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade modal--mini" id="edit-exit-modal" tabindex="-1" aria-labelledby="exit-modal"  aria-modal="true" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-mini">
      <div class="modal-mini__heading">
        <div class="container-fluid">
          <h4>Are you sure you want to exit?</h4>
        </div>
      </div>

      <div class="modal-mini__content">
        <div class="container-fluid">
          <div class="rte">
            <p>By leaving now, all of your changes to this policy will be discarded. Once gone, these changes
            will not be recoverable.</p>

            <p>Are you sure you want to continue?</p>
          </div>
        </div>
      </div>

      <div class="modal-mini__button">
        <div class="container-fluid">
          <a href="javascript:;" (click)="discardChanges()" data-dismiss="modal" class="button button--secondary" id="discard-changes-demo-btn">Discard changes</a>
          <a href="#" data-dismiss="modal" class="button button--primary">Go back</a>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade modal--alert" id="modal-additional" tabindex="-1" role="dialog" aria-labelledby="modal-additional-qs-1" aria-modal="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--alt">

      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">
            <img src="assets/{{item?.category_id}}/avatar/happy.png" class="img-fluid" alt="">
          </div>
          <button class="modal-alert__close" data-dismiss="modal">
            <svg class="icon"><use xlink:href="#close-medium"></use></svg>
          </button>
        </div>
      </div>

      <div class="modal-alert__content">
        <div class="container">
          <div class="rte">
            <h3>Changing this answer may require additional questions.</h3>
            <p>Note that changes may affect your premium. All previously answered questions that don’t require changes will still be saved.</p>
          </div>
        </div>

      </div>


      <div class="modal-alert__button">
        <div class="container">
          <a href="#" (click)="revertAnswer()"  class="button button--lg button--secondary" data-dismiss="modal">Cancel</a>
          <a href="#" class="button button--lg button--primary" (click)="startDependentFlow()" data-toggle="modal" data-dismiss="modal">Got it</a>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade modal--tray" id="edit-modal-add-menu" tabindex="-1" role="dialog" aria-labelledby="edit-modal-add-menu" aria-modal="true" >
  <div class="modal-dialog">
    <div class="modal-content modal-traymenu">
      <div class="container">
        <div class="modal-traymenu__list list-unstyled">
          <a href="javascript:;" (click)="addCover()" class="modal-traymenu__list-item">
            <svg class="icon">
              <use xlink:href="#insured-items-add"></use>
            </svg>
            <span>Add an insured item</span>
          </a>
          <a href="javascript:;" (click)="addBenefit()" class="modal-traymenu__list-item">
            <svg class="icon">
              <use xlink:href="#benefit-add"></use>
            </svg>
            <span>Add a benefit</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade modal--tray" id="edit-modal-remove-menu" tabindex="-1" aria-labelledby="edit-modal-remove-menu" aria-modal="true" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content modal-traymenu">
      <div class="container">
        <div class="modal-traymenu__list list-unstyled">
          <a href="#remove-insured-select-modal" data-toggle="modal" class="modal-traymenu__list-item">
            <svg class="icon">
              <use xlink:href="#insured-items-remove"></use>
            </svg>
            <span>Remove an insured item</span>
          </a>
          <a href="#remove-benefit-select-modal" data-toggle="modal" class="modal-traymenu__list-item">
            <svg class="icon">
              <use xlink:href="#benefit-remove"></use>
            </svg>
            <span>Remove a benefit</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade modal--tray" id="modal-traymenu-insured-items" tabindex="-1" role="dialog" aria-labelledby="modal-traymenu-insured-items" aria-modal="true">
  <div class="modal-dialog">
    <div class="modal-content modal-traymenu">
      <div class="container">
        <div class="modal-traymenu__list list-unstyled">
          <a href="javascript:;" data-dismiss="modal" class="modal-traymenu__list-item is-active dd-0" (click)="setFilterClass('All',0)">
            <div>All insured items</div>
          </a>
          @for (class of classes; track class) {
            @if (getClassItems(class?.class_id)?.length > 0) {
              <a href="javascript:;" data-dismiss="modal" class="modal-traymenu__list-item dd-{{class?.class_id}}" (click)="setFilterClass(class,0)">
                <div>{{class?.description_1}}</div>
              </a>
            }
          }
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade modal--tray" id="modal-traymenu-benefits" tabindex="-1" role="dialog" aria-labelledby="modal-traymenu-benefits" aria-modal="true">
  <div class="modal-dialog">
    <div class="modal-content modal-traymenu">
      <div class="container">
        <div class="modal-traymenu__list list-unstyled">
          <a href="javascript:;" data-dismiss="modal"  class="modal-traymenu__list-item is-active dd-0" (click)="setFilterClass('All',0)">
            <div>All benefits</div>
          </a>
          @for (class of getBenefitsClasses(); track class) {
            <a href="javascript:;" data-dismiss="modal" class="modal-traymenu__list-item dd-{{class?.class_id}}" (click)="setFilterClass(class,1)">
              <div>{{class?.class_name}}</div>
            </a>
          }
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade modal--tray " id="edit-modal-more-menu" tabindex="-1" role="dialog" aria-labelledby="edit-modal-more-menu" aria-modal="true" >
  <div class="modal-dialog">
    <div class="modal-content modal-traymenu">
      <div class="container">
        <div class="modal-traymenu__list list-unstyled">

          <a href="javascript:;" (click)="cancelCover(Entities.Policy)" data-dismiss="modal" class="modal-traymenu__list-item">
            <svg class="icon">
              <use xlink:href="#cancelled"></use>
            </svg>
            <span>Cancel this policy</span>
          </a>
          <!-- <a href="javascript:;" (click)="openInceptionDateModal()" data-dismiss="modal" class="modal-traymenu__list-item">
          <svg class="icon">
            <use xlink:href="#circle-change"></use>
          </svg>
          <span>Change inception date</span>
        </a> -->
        <a href="everything.policy-edit-entire.change-product.html" class="modal-traymenu__list-item is-disabled">
          <svg class="icon">
            <use xlink:href="#circle-change"></use>
          </svg>
          <span>Change Product</span>
        </a>
      </div>
    </div>
  </div>
</div>
</div>